import { OVERLAY_CONFIG } from '@shared/config'

export const buildGamesUrl = (): string => `${OVERLAY_CONFIG.WS_BASE_URL}/games`

export const GAMES_SOCKET_OPTIONS = {
  transports: ['websocket'] as ('websocket')[],
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 500,
  reconnectionDelayMax: 5_000,
}
